import React from 'react';
import { API } from 'aws-amplify';
import { toast } from 'react-toastify';
import { t } from 'i18next';

import reducer from './reducer';

const useScholarshipData = (AppInstID, Status, handleClose) => {
    const [scholarshipData, dispatch] = React.useReducer(reducer, { AppInstID, Status, Loading: true });

    const retrieveScholarshipData = async () => {
        try {
            let response = await API.get('ShipyardAPI', `/applications/${scholarshipData.AppInstID}/scholarship_data`, {
                queryStringParameters: {
                    status: scholarshipData.Status,
                },
            });

            dispatch({
                type: 'retrieved',
                newState: response.scholarshipData,
            });
        } catch (e) {
            toast.error(t('General.AjaxError'));
        }
    };

    const acceptScholarship = async () => {
        const id = toast.loading('Accepting the scholarship...');
        try {
            await API.patch('ShipyardAPI', `/application/${scholarshipData.AppInstID}`, {
                body: {
                    status: 9,
                },
            });

            toast.success('Scholarship accepted');

            handleClose?.(true);
        } catch (e) {
            toast.error(t('General.AjaxError'));
        } finally {
            toast.dismiss(id);
        }
    };

    const declineScholarship = async () => {
        const id = toast.loading('Declining the scholarship...');
        try {
            await API.patch('ShipyardAPI', `/application/${scholarshipData.AppInstID}`, {
                body: {
                    status: 10,
                },
            });

            toast.success('Scholarship declined');

            handleClose?.(true);
        } catch (e) {
            toast.error(t('General.AjaxError'));
        } finally {
            toast.dismiss(id);
        }
    };

    return { scholarshipData, retrieveScholarshipData, acceptScholarship, declineScholarship };
};

export default useScholarshipData;
